if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        // Vivaraki, Kadir 10 okt 2026: op mobiel opent de zoom in het midden van de foto, niet aan de bovenrand
        // (klanten zagen alleen wit en raakten de weg kwijt). Ook opnieuw zodra een trage foto binnen is.
        if (window.matchMedia('(max-width: 749px)').matches) {
          const midden = () => {
            container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;
            container.scrollTop = Math.max(0, activeMedia.offsetTop + (activeMedia.offsetHeight - container.clientHeight) / 2);
          };
          midden();
          if (activeMedia.nodeName === 'IMG' && !activeMedia.complete) activeMedia.addEventListener('load', midden, { once: true });
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
